/**
 * 주문 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class OrderService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 신규주문
     * 거래 > 주문 > 신규주문시 사용한다.
     * @returns 신규주문 결과
     */
    createNewOrder(request) {
        return this.axios.post(`/main/v1/orders`, request);
    }
    /**
     * TPSL주문
     * 거래 > 주문 > TPSL주문시 사용한다.
     * @returns TPSL주문 결과
     */
    createTpslOrder(request) {
        return this.axios.post(`/main/v1/orders/tpsl`, request);
    }
    /**
     * 정정주문
     * 거래 > 주문 > 정정주문시 사용한다.
     * @returns 정정주문 결과
     */
    createModifyOrder(request) {
        return this.axios.post(`/main/v1/orders/modify`, request);
    }
    /**
     * 청산주문
     * 거래 > 주문 > 청산주문시 사용한다.
     * @returns 청산주문 결과
     */
    createCloseOutOrder(request) {
        return this.axios.post(`/main/v1/orders/close-out`, request);
    }
    /**
     * 취소주문
     * 거래 > 주문 > 취소주문시 사용한다.
     * @returns 취소주문 결과
     */
    createCancelOrder(request) {
        return this.axios.post(`/main/v1/orders/cancel`, request);
    }
}
//# sourceMappingURL=order.service.js.map